import React from 'react';
import styled from 'styled-components';
import { NumberInput, NumberInputProps } from '/imports/ui/NumberInput';

const CurrencyInputStyled = styled(NumberInput)`
`;

/** Number input styled as a currency field with a leading dollar icon. */
export const CurrencyInput = (props: NumberInputProps) => {
  return (
    <CurrencyInputStyled
      {...props}
      className={`currency-input ${props.className || ''}`}
      step={props.step || '0.01'}
      min={props.min || '0'}
      decimals={props.decimals ?? 2}
      iconPlacement="start"
      icon="attachMoney"
    />
  );
};